<template>
  <section>
    <h2 class="h2Title">팝업 관리</h2>
    <article class="fieldMb">
      <form class="fieldWrap">
        <div class="fieldBx">
          <ul>
            <li class="formList">

              <dl>
                <dd>
                      <v-select :items="popupCategoryList" v-model="param.searchCategory" label="팝업 카테고리" item-text="text"
                                item-value="value"
                                dense solo flat outlined clearable
                                v-on:change="search"
                      />
                </dd>
              </dl>
              <dl>
                <dd>
                  <date-range-component v-on:event="getSearchDate" label="팝업생성일"
                                        :value="param.searchDate"></date-range-component>
                </dd>
                <dd>
                  <div class="monthBx">
                    <button type="button" class="btn month" v-for="(month, idx) in monthLists"
                            :class="{ active: month === activeItem}"
                            @click="selectSearchDate(month.value, idx)" :key="idx">{{ month.text }}
                    </button>
                  </div>
                </dd>
              </dl>
              <dl>
                <dd>
                  <v-col sm="6">
                      <v-text-field  v-model="param.searchKeyword" v-on:keyup.enter="search" label="제목 / 내용 검색" dense solo clearable flat outlined />
                  </v-col>
                </dd>
              </dl>

            </li>
          </ul>
        </div>
      </form>
    </article>
    <article class="tableWrap">
      <div class="tableBtnBx">
        <p class="searchAll">
        </p>
        <div class="tableBtn">
          <ul>
            <li class="tableBtnList">
              <v-btn class="vBtn vIconResize mgr" @click="$router.push({path: `/popup/form`})">
                <v-icon left>mdi mdi-playlist-plus</v-icon> 등록
              </v-btn>
            </li>
          </ul>
        </div>
      </div>
      <div class="tableBx">
        <v-data-table
            :headers="headers"
            :items="datasets"
            :server-items-length="totalItems"
            :options.sync="options"
            class="elevation-1"
            disable-sort
        >
          <template v-slot:item.createdAt="{ value }">
            {{ value | moment('YYYY.MM.DD HH:mm') }}
          </template>
          <template v-slot:item.start_date="{ item }">
            {{ item.start_date ? $moment(item.start_date, 'YYYYMMDDHHmmss').format('YYYY.MM.DD') : '' }}
          </template>
          <template v-slot:item.end_date="{ item }">
            {{ item.end_date ? $moment(item.end_date, 'YYYYMMDDHHmmss').format('YYYY.MM.DD') : '' }}
          </template>
          <template v-slot:item.layer="{ value }">
            {{ value ? '레이어' : '팝업' }}
          </template>
          <template v-slot:item.activated="{ value }">
            {{ value ? '노출' : '노출 안함' }}
          </template>
          <template v-slot:item.always="{ value, item }">
            {{ value ? '상시' : `${item.startDt} ${item.startTm} ~ ${item.endDt} ${item.endTm} ` }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon
                small
                class="mr-2"
                @click="updateForm(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
                small
                @click="deletePopup(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>

      </div>
    </article>

  </section>
</template>
<script>

import popupApi from '@/api/PopupApi';
import 'codemirror/lib/codemirror.css';
import '@toast-ui/editor/dist/toastui-editor.css';
import DateRageComponent from "@/views/component/DateRageComponent";

export default {
  name: 'Popup',
  components: {
    'date-range-component': DateRageComponent,
  },
  data: () => ({
        monthLists: [
          {value: 1, text: '1개월'}, {value: 3, text: '3개월'}, {value: 6, text: '6개월'},
          {value: 12, text: '1년'}, {value: 0, text: '전체'}],
        activeItem: null,
        searchPopupCategory : '',
        searchField : 'popup_name',
        searchValue : '',
        popup:{},
        datasets: [],
        totalItems: 0,
        options:{},
        param: {
          searchDate:[],
          searchKeyword: null,
          page: 1
        },
        headers:[
          {
            text: '팝업 명',
            value: 'title',
            align: 'left',
            sortable: false
          },
          {
            text: '팝업 카테고리',
            value: 'popupCategory',
            align: 'left',
            sortable: false
          },
          {
            text: '팝업타입',
            value: 'layer',
            align: 'left',
            sortable: false
          },
          {
            text: '노출 여부',
            value: 'activated',
            align: 'left',
            sortable: false
          },
          {
            text: '노출 기간',
            value: 'always',
            align: 'center',
            sortable: false
          },
          {
            text: '생성일',
            value: 'createdAt',
            align: 'center',
            sortable: false
          },
          {
            text: 'Actions',
            value: 'actions',
            align: 'left',
            sortable: false
          }
        ],
        pagination: {
          sortBy: 'createdAt',
          rowsPerPage: 20
        },
        popupCategoryList: [],
        waitingSearch: false,
      }
  ),
  watch: {
    options: {
      handler() {
        this.search();
      },
      deep: true,
    },
    'param.searchKeyword': {
      handler(nv) {
        this.options.page = 1;
        this.param.searchKeyword = nv;
        if (!this.waitingSearch) {
          setTimeout(() => {
            this.search();
            this.waitingSearch = false;
          }, 500); // 0.5 sec delay
        }
        this.waitingSearch = true;
      },
      deep: true
    },
    'param.searchDate': {
      handler() {
        this.search();
      },
      deep: true
    }
  },
  methods: {
    search() {
      const {  page, itemsPerPage, size } = this.options;

      let params = {...this.param, ...{
          page: page,
          size: size ? size : itemsPerPage
        }};
      if (this.param.searchDate?.length??0 > 0) {
        params.fromDate = this.param.searchDate[0];
        params.toDate = this.param.searchDate?.[1]??this.param.searchDate[0];
      } else {
        params.fromDate = null;
        params.toDate = null;
      }
      if (this.param.searchDate?.length??0 > 0) {
        params.fromDate = this.param.searchDate[0];
        params.toDate = this.param.searchDate?.[1]??this.param.searchDate[0];
      } else {
        params.fromDate = null;
        params.toDate = null;
      }

      popupApi.list(this.searchPopupCategory, params).then(data => {
        this.datasets = data.content;
        this.totalItems = data.totalElements;
        this.$store.commit('setParams', params);
      });
    },
    getSearchDate(searchDate = []) {
      this.param.searchDate = searchDate;
    },
    selectSearchDate(months) {
      this.activeItem = months;
      // 0 is total
      if (this.activeItem !== 0) {
        this.param.searchDate = [this.$moment().subtract(months, "months").format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
      } else
        this.param.searchDate = [];
    },
    updateForm(item) {
      this.$router.push({path:`/popup/form/${item.popupId}`});
    },
    async deletePopup(item) {
      if (confirm(`${item.title} 를 삭제하시겠습니까?`)) {
        popupApi.delete(item.popupId).then(() => {
          this.search();
        });
      }
    },
  },
  created() {

    const storedParams = this.$store.getters?.params??{};
    if(storedParams.name !== this.$options.name)
      this.$store.commit('setParams', Object.assign(this.param, {name:this.$options.name}))
    else {
      this.options = storedParams
      this.param = storedParams
    }

    popupApi.getCategory().then(data => {
      this.popupCategoryList = data.map(c => { return {value:c, text:c}})
    })
  }

}
</script>


<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.7%;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          span {
            margin-left: 8px;
          }

          &:nth-child(2) {
            padding-left: 5px;
            padding-bottom: 3px;
          }

          .monthBx {
            display: flex;
            align-items: center;
            height: 35px;
            width: 280px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }
              width: 55px;
              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
      .txtPoint {
        color: $point-color;
      }
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        //margin-right: 15px;
      }
    }
  }
}
</style>
